import { Outlet, Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useRefreshMutation } from "./authApiSlice";
import usePersist from "../../hooks/usePersist";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "./authSlice";
import PulseLoader from "react-spinners/PulseLoader";

// const PersistLogin = () => {
//   const [persist] = usePersist();
//   const token = useSelector(selectCurrentToken);
//   const effectRan = useRef(false);

//   const [trueSuccess, setTrueSuccess] = useState(false);

//   const [refresh, { isUninitialized, isLoading, isSuccess, isError, error }] =
//     useRefreshMutation();

//   useEffect(() => {
//     if (effectRan.current === true || process.env.NODE_ENV !== "development") {
//       // React 18 Strict Mode

//       const verifyRefreshToken = async () => {
//         console.log("verifying refresh token");
//         try {
//           //const response =
//           await refresh();
//           //const { accessToken } = response.data
//           setTrueSuccess(true);
//         } catch (err) {
//           console.error(err);
//         }
//       };

//       if (!token && persist) verifyRefreshToken();
//     }

//     return () => (effectRan.current = true);
//   }, []);

//   let content;
//   if (!persist) {
//     // persist: no
//     console.log("no persist");
//     content = <Outlet />;
//   } else if (isLoading) {
//     //persist: yes, token: no
//     console.log("loading");
//     content = <PulseLoader color={"#FFF"} />;
//   } else if (isError) {
//     //persist: yes, token: no
//     console.log("error");
//     content = (
//       // <p className='errmsg'>
//       //     {`${error?.data?.message} - `}
//       //     <Link to="/">Molim vas ulogujte se ponovo klikom ovde</Link>.
//       // </p>
//       <p className="bg-red-100 text-red-800 border border-red-400 rounded-md p-6 flex items-center text-lg">
//         <span className="font-semibold text-xl">
//           {`${error?.data?.message}`}
//         </span>
//         <Link
//           to="/"
//           className="ml-4 text-blue-600 hover:text-blue-800 font-medium text-lg"
//         >
//           Molim vas ulogujte se ponovo klikom ovde.
//         </Link>
//       </p>
//     );
//   } else if (isSuccess && trueSuccess) {
//     //persist: yes, token: yes
//     console.log("success");
//     content = <Outlet />;
//   } else if (token && isUninitialized) {
//     //persist: yes, token: yes
//     console.log("token and uninit");
//     console.log(isUninitialized);
//     content = <Outlet />;
//   }

//   return content;
// };

const PersistLogin = () => {
  const token = useSelector(selectCurrentToken);
  const [refresh, { isLoading, isError, error }] = useRefreshMutation();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const verifyRefreshToken = async () => {
      if (!token) {
        // console.log("Ovde toke", token);
        try {
          await refresh(); // Poziva backend za osvežavanje tokena
          setIsVerified(true); // Token uspešno osvežen
        } catch (err) {
          console.error("Error refreshing token:", err);
        }
      } else {
        setIsVerified(true); // Token već postoji
      }
    };

    verifyRefreshToken();
  }, [token, refresh]);

  if (isLoading) {
    return <PulseLoader color={"#FFF"} />;
  }

  if (isError) {
    return (
      <div className="max-w-xl mx-auto mt-10 p-6 bg-white border border-red-300 rounded-lg shadow-lg flex items-start space-x-4">
        {/* Ikonica upozorenja */}
        <div className="flex-shrink-0">
          <svg
            className="w-8 h-8 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 
              1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.35 
              16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        {/* Tekstualna poruka */}
        <div>
          <h2 className="text-lg font-semibold text-red-600 mb-1">
            Greška u autorizaciji
          </h2>
          <p className="text-gray-700 mb-2">
            {error?.data?.message || "Nemate pristup ili je sesija istekla."}
          </p>
          <Link
            to="/"
            className="inline-block text-blue-600 hover:underline font-medium"
          >
            Prijavite se ponovo klikom ovde
          </Link>
        </div>
      </div>
    );
  }

  return isVerified ? <Outlet /> : null;
};

export default PersistLogin;
